document.addEventListener("DOMContentLoaded", function () {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
  gsap.registerPlugin(ScrollTrigger);

  document.querySelectorAll(".sc-section").forEach(function (section) {
    var isMobile = window.innerWidth < 768;
    var titleBarH = isMobile ? 48 : 60;
    var titleScaleEnd = isMobile ? 0.8 : 0.7;
    var scrollPerCard = isMobile ? 250 : 350;
    var overlap = 0.4;

    var cardsArea = section.querySelector(".sc-cards-area");
    var headerEl = section.querySelector(".sc-header");
    if (!cardsArea || !headerEl) return;

    var boxes = gsap.utils.toArray(cardsArea.querySelectorAll(".sc-card"));
    var total = boxes.length;
    if (total < 1) return;

    var titles = boxes.map(function (b) { return b.querySelector("h2"); });

    var maxCardH = 0;
    boxes.forEach(function (box) {
      gsap.set(box, { position: "relative", top: "auto" });
    });
    boxes.forEach(function (box) {
      var h = box.offsetHeight;
      if (h > maxCardH) maxCardH = h;
    });

    var stackedH = (total - 1) * titleBarH + maxCardH;
    cardsArea.style.height = stackedH + "px";

    var offScreenY = window.innerHeight;

    boxes.forEach(function (box, i) {
      gsap.set(box, { position: "absolute" });
      if (i === 0) {
        gsap.set(box, { top: 0 });
      } else {
        gsap.set(box, { top: offScreenY });
      }
    });

    var tl = gsap.timeline();

    for (var i = 1; i < total; i++) {
      var stackY = i * titleBarH;
      var startTime = (i - 1) * overlap;

      tl.to(boxes[i], {
        top: stackY,
        duration: 1,
        ease: "power2.out"
      }, startTime);

      tl.to(titles[i - 1], {
        scale: titleScaleEnd,
        y: -15,
        duration: 0.4,
        ease: "none"
      }, startTime + 0.1);
    }

    var totalScroll = scrollPerCard * total;

    ScrollTrigger.create({
      trigger: section,
      start: "top top",
      end: "+=" + totalScroll,
      pin: true,
      pinSpacing: true,
      scrub: 0.5,
      animation: tl
    });
  });
});